import { useEffect, useReducer, useRef } from 'react';

const reducer = (state, action) => {
  switch (action.type) {
    case 'speed':
      return {
        ...state,
        speed: action.payload,
      };
    case 'type':
      return {
        speed: action.speed,
        text: action.payload.substring(0, state.text.length + 1),
      };
    case 'delete':
      return {
        ...state,
        speed: action.speed,
        text: action.payload.substring(0, state.text.length - 1),
      };
    default:
      return state;
  }
};

export const useTypewriter = ({
  words,
  autoloop,
  typeSpeed,
  deleteSpeed,
  delaySpeed,
}) => {
  const [{ speed, text }, dispatch] = useReducer(reducer, {
    speed: 0,
    text: '',
  });

  // Refs
  const count = useRef(0);
  const isDelete = useRef(false);
  const isDone = useRef(false);

  const handleTyping = () => {
    const index = count.current % words.length;
    const word = words[index];

    dispatch({ type: 'speed', payload: typeSpeed });

    if (isDelete.current) {
      dispatch({ type: 'delete', payload: word, speed: deleteSpeed });

      if (text === '') {
        isDelete.current = false;
        count.current += 1;
      }
    } else {
      dispatch({ type: 'type', payload: word, speed: typeSpeed });

      if (text === word) {
        dispatch({ type: 'speed', payload: delaySpeed });
        isDelete.current = true;

        if (!autoloop) {
          isDone.current = true;
        }
      }
    }
  };

  useEffect(() => {
    const typing = setTimeout(handleTyping, speed);

    if (isDone.current) {
      clearTimeout(typing);
    }

    return () => clearTimeout(typing);
  }, [handleTyping, speed]);

  return { text, count: count.current };
};
